<template>
	<div>
		<pm-header>
			<template slot="contenido">
				<div class="row h-100 d-flex align-items-center fondo-header m-0">
					<div
						class="col-12 col-sm-10 offset-sm-1 col-lg-5 offset-lg-2 text-center text-lg-left text-white"
						data-aos="fade-right"
						data-aos-delay="750"
					>
						<p class="fuente-header-titulo p-0 m-0">Nuestras puertas</p>
						<p class="fuente-header-subtitulo p-0 m-0">est&aacute;n abiertas.</p>
					</div>
					<div class="col-lg-3 d-none d-lg-block" data-aos="fade-left" data-aos-delay="500">
						<img class="img-fluid" src="@/assets/img-pub/ContactoLG.png" />
					</div>
				</div>
			</template>
		</pm-header>

		<div class="container">
			<div class="row mt-5 d-flex align-items-end">
				<div class="col-sm-12 col-md-6">
					<pm-contacto-mapa></pm-contacto-mapa>
				</div>
				<div class="col-sm-12 col-md-6">
					<pm-contacto-formulario></pm-contacto-formulario>
				</div>
			</div>

			<div class="row mt-5">
				<div class="col-sm-12 col-md-3">
					<div class="d-flex justify-content-center">
						<i class="fa fa-map-marker-alt mr-2 mt-1 iconoStyle"></i>
						<a
							class="fuente-sucursal-nombre"
							href="https://www.google.com.mx/maps/place/Difarmer,+S.A.+de+C.V./@21.101243,-101.7161961,18z/data=!4m5!3m4!1s0x842bc070ee98bbef:0x13f38528a7617f75!8m2!3d21.1008877!4d-101.7147343"
							target="_black"
						>León, Guanajuato</a>
					</div>
					<p class="fuente-sucursal-direccion text-center">
						Blvd. Torres Landa Pte No. 1867, Industrial San Crispin,
						C.P. 37438, León, Guanajuato.
						<br />Tel: (477) 778 0720
					</p>
				</div>
				<div class="col-sm-12 col-md-3">
					<div class="d-flex justify-content-center">
						<i class="fa fa-map-marker-alt mr-2 mt-1 iconoStyle"></i>
						<a
							class="fuente-sucursal-nombre"
							href="https://www.google.com/maps/place/Difarmer+-+Torre%C3%B3n/@25.5792465,-103.4419971,17z/data=!3m1!4b1!4m6!3m5!1s0x868fdbf353c11359:0x81dc2af8c9bfca7b!8m2!3d25.5792417!4d-103.4394222!16s%2Fg%2F11ts4bk5d8?authuser=0&entry=ttu"
							target="_black"
						>Torreón, Coahuila</a>
					</div>
					<p class="fuente-sucursal-direccion text-center">
						Periférico Raúl López Sánchez, Fraccionamiento el Roble, 
						<br />C.P. 27119, Torreón, Coahuila.
						<br />Tel: (871) 688 1437
					</p>
				</div>
				<div class="col-sm-12 col-md-3">
					<div class="d-flex justify-content-center">
						<i class="fa fa-map-marker-alt mr-2 mt-1 iconoStyle"></i>
						<a
							class="fuente-sucursal-nombre"
							href="https://www.google.com.mx/maps/place/Difarmer,+S.A.+de+C.V./@19.0609349,-98.1106987,17z/data=!3m1!4b1!4m5!3m4!1s0x85cfeb533a47949f:0x36fd76f8862849c3!8m2!3d19.0609298!4d-98.10851"
							target="_black"
						>Puebla, Puebla</a>
					</div>
					<p class="fuente-sucursal-direccion text-center">
						Carretera Internacional No. 1, Parque Industrial Chachapa,
						C.P. 72990, Puebla, Puebla.
						<br />Tel: (222) 290 8769
					</p>
				</div>
				<div class="col-sm-12 col-md-3">
					<div class="d-flex justify-content-center">
						<i class="fa fa-map-marker-alt mr-2 mt-1 iconoStyle"></i>
						<a
							class="fuente-sucursal-nombre"
							href="https://www.google.com.mx/maps/place/Difarmer,+S.A+de+C.V/@20.5550091,-100.2740838,19z/data=!4m5!3m4!1s0x85d35d18853a2ecf:0x93cc4793e9056f60!8m2!3d20.5551281!4d-100.2735728"
							target="_black"
						>Querétaro, Qro</a>
					</div>
					<p class="fuente-sucursal-direccion text-center">
						Parque tecnológico innovación Querétaro, 
						Lote 43, C.P. 76246 Santiago de Querétaro, Qro.
						<br />Tel: (442) 629 9007
					</p>
				</div>
				<div class="col-sm-12 col-md-3">
					<div class="d-flex justify-content-center">
						<i class="fa fa-map-marker-alt mr-2 mt-1 iconoStyle"></i>
						<a
							class="fuente-sucursal-nombre"
							href="https://goo.gl/maps/SksNRRtSXsiFVbEx5"
							target="_black"
						>Mexicali,B.C.</a>
					</div>
					<p class="fuente-sucursal-direccion text-center">
						Carr. de Mexicali km 17,
						Aeropuerto C.P. 21607 Mexicali, B.C.
						<br />Tel: (686) 488 0754
					</p>
				</div>
			</div>
		</div>

		<pm-pie-pagina></pm-pie-pagina>
	</div>
</template>

<script>
	import PmHeader from "@/components/publica/Header"
	import PmContactoMapa from "@/components/publica/ContactoMapa"
	import PmContactoFormulario from "@/components/publica/ContactoFormulario"
	import PmPiePagina from "@/components/publica/PiePagina"
	export default {
		components: {
			PmHeader,
			PmPiePagina,
			PmContactoMapa,
			PmContactoFormulario
		},
		mounted() {
			//this.ocultarChat()
		}
	}
</script>

<style scoped>
	.fondo-header {
		/* background-image: url(""); */
		background-repeat: no-repeat, repeat;
		background-size: cover;
		background-position: center;
	}
	.fuente-header-titulo {
		font-weight: 600;
		color: var(--color-blanco);
	}
	.fuente-header-subtitulo {
		color: var(--color-blanco);
	}
	.iconoStyle {
		font-size: 20px;
		color: var(--color-azul);
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.fondo-header {
			background-image: url("../../assets/img-pub/ContactoXS.png");
		}
		.fuente-header-titulo {
			font-size: 30px !important;
		}
		.fuente-header-subtitulo {
			font-size: 28px !important;
		}
		.fuente-sucursal-nombre {
			font-size: 18px !important;
			font-family: "Open Sans" !important;
			color: var(--color-azul);
			font-weight: bold;
		}
		.fuente-sucursal-direccion {
			font-size: 10px !important;
			font-family: "Open Sans" !important;
			font-weight: normal;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.fondo-header {
			background-image: url("../../assets/img-pub/ContactoXS.png");
		}
		.fuente-header-titulo {
			font-size: 43px !important;
		}
		.fuente-header-subtitulo {
			font-size: 43px !important;
		}
		.fuente-sucursal-nombre {
			font-size: 18px !important;
			font-family: "Open Sans" !important;
			color: var(--color-azul);
			font-weight: bold;
		}
		.fuente-sucursal-direccion {
			font-size: 10px !important;
			font-family: "Open Sans" !important;
			font-weight: normal;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.fondo-header {
			background-image: url("../../assets/img-pub/ContactoXS.png");
		}
		.fuente-header-titulo {
			font-size: 43px !important;
		}
		.fuente-header-subtitulo {
			font-size: 43px !important;
		}
		.fuente-sucursal-nombre {
			font-size: 18px !important;
			font-family: "Open Sans" !important;
			color: var(--color-azul);
			font-weight: bold;
		}
		.fuente-sucursal-direccion {
			font-size: 10px !important;
			font-family: "Open Sans" !important;
			font-weight: normal;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.fuente-header-titulo {
			font-size: 43px !important;
		}
		.fuente-header-subtitulo {
			font-size: 43px !important;
		}
		.fuente-sucursal-nombre {
			font-size: 22px !important;
			font-family: "Open Sans" !important;
			color: var(--color-azul);
			font-weight: bold;
		}
		.fuente-sucursal-direccion {
			font-size: 13px !important;
			font-family: "Open Sans" !important;
			font-weight: normal;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.fuente-header-titulo {
			font-size: 55px !important;
		}
		.fuente-header-subtitulo {
			font-size: 50px !important;
		}
		.fuente-sucursal-nombre {
			font-size: 24px !important;
			font-family: "Open Sans" !important;
			color: var(--color-azul);
			font-weight: bold;
		}
		.fuente-sucursal-direccion {
			font-size: 15px !important;
			font-family: "Open Sans" !important;
			font-weight: normal;
		}
	}
</style>